// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId);
var compare = /* #__PURE__ */ Data_Ord.compare(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId);
var compare1 = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordInt);
var ProductPackagingFeeSubjectIsSymbol = {
    reflectSymbol: function () {
        return "ProductPackagingFeeSubject";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var modifierItemIsSymbol = {
    reflectSymbol: function () {
        return "modifierItem";
    }
};
var ModifierItemPackagingFeeSubjectIsSymbol = {
    reflectSymbol: function () {
        return "ModifierItemPackagingFeeSubject";
    }
};
var decodeSingleConstructorAr = /* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr();
var orderLineIndexIsSymbol = {
    reflectSymbol: function () {
        return "orderLineIndex";
    }
};
var subjectIsSymbol = {
    reflectSymbol: function () {
        return "subject";
    }
};
var typeIdIsSymbol = {
    reflectSymbol: function () {
        return "typeId";
    }
};
var PackagingFeeItemIsSymbol = {
    reflectSymbol: function () {
        return "PackagingFeeItem";
    }
};
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId);
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons1 = /* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil);
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId);
var ProductPackagingFeeSubject = /* #__PURE__ */ (function () {
    function ProductPackagingFeeSubject() {

    };
    ProductPackagingFeeSubject.value = new ProductPackagingFeeSubject();
    return ProductPackagingFeeSubject;
})();
var ModifierItemPackagingFeeSubject = /* #__PURE__ */ (function () {
    function ModifierItemPackagingFeeSubject(value0) {
        this.value0 = value0;
    };
    ModifierItemPackagingFeeSubject.create = function (value0) {
        return new ModifierItemPackagingFeeSubject(value0);
    };
    return ModifierItemPackagingFeeSubject;
})();
var PackagingFeeItem = /* #__PURE__ */ (function () {
    function PackagingFeeItem(value0) {
        this.value0 = value0;
    };
    PackagingFeeItem.create = function (value0) {
        return new PackagingFeeItem(value0);
    };
    return PackagingFeeItem;
})();
var toFillFormTypePackagingFe = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeExtraFeeIte = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqPackagingFeeSubject = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ProductPackagingFeeSubject && y instanceof ProductPackagingFeeSubject) {
                return true;
            };
            if (x instanceof ModifierItemPackagingFeeSubject && y instanceof ModifierItemPackagingFeeSubject) {
                return eq(x.value0.modifierItem)(y.value0.modifierItem);
            };
            return false;
        };
    }
};
var eq2 = /* #__PURE__ */ Data_Eq.eq(eqPackagingFeeSubject);
var ordPackagingFeeSubject = {
    compare: function (x) {
        return function (y) {
            if (x instanceof ProductPackagingFeeSubject && y instanceof ProductPackagingFeeSubject) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ProductPackagingFeeSubject) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ProductPackagingFeeSubject) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ModifierItemPackagingFeeSubject && y instanceof ModifierItemPackagingFeeSubject) {
                return compare(x.value0.modifierItem)(y.value0.modifierItem);
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.ExtraFeeItem (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqPackagingFeeSubject;
    }
};
var compare2 = /* #__PURE__ */ Data_Ord.compare(ordPackagingFeeSubject);
var eqExtraFeeItem = {
    eq: function (x) {
        return function (y) {
            return x.value0.orderLineIndex === y.value0.orderLineIndex && eq2(x.value0.subject)(y.value0.subject) && eq(x.value0.typeId)(y.value0.typeId);
        };
    }
};
var ordExtraFeeItem = {
    compare: function (x) {
        return function (y) {
            var v = compare1(x.value0.orderLineIndex)(y.value0.orderLineIndex);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            var v1 = compare2(x.value0.subject)(y.value0.subject);
            if (v1 instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v1 instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return compare(x.value0.typeId)(y.value0.typeId);
        };
    },
    Eq0: function () {
        return eqExtraFeeItem;
    }
};
var genericPackagingFeeSubject = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return ProductPackagingFeeSubject.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new ModifierItemPackagingFeeSubject(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.ExtraFeeItem (line 18, column 1 - line 18, column 93): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ProductPackagingFeeSubject) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ModifierItemPackagingFeeSubject) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.ExtraFeeItem (line 18, column 1 - line 18, column 93): " + [ x.constructor.name ]);
    }
};
var showPackagingFeeSubject = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPackagingFeeSubject)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(ProductPackagingFeeSubjectIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(modifierItemIsSymbol)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))))(ModifierItemPackagingFeeSubjectIsSymbol)))
};
var unscrambleDecodePackagingFeeSubject = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPackagingFeeSubject)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)(ProductPackagingFeeSubjectIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ModifierItemPackagingFeeSubjectIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(modifierItemIsSymbol)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericExtraFeeItem = {
    to: function (x) {
        return new PackagingFeeItem(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var showExtraFeeItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericExtraFeeItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(orderLineIndexIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(subjectIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(typeIdIsSymbol)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))(showPackagingFeeSubject))(Data_Show.showInt))))(PackagingFeeItemIsSymbol))
};
var unscrambleDecodeExtraFeeItem = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecodeTagged(genericExtraFeeItem)(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(PackagingFeeItemIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(orderLineIndexIsSymbol)(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons(subjectIsSymbol)(unscrambleDecodePackagingFeeSubject)(/* #__PURE__ */ Unscramble.decodeRecordCons(typeIdIsSymbol)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodingOptsExtraFeeItem = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform,
        unwrapSingleConstructors: true,
        unwrapSingleRecordArguments: true
    };
})();
var encodePackagingFeeSubject = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPackagingFeeSubject)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ProductPackagingFeeSubjectIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ModifierItemPackagingFeeSubjectIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons1(modifierItemIsSymbol)(encodeWithOptionsOther))))))
};
var encodeExtraFeeItem = /* #__PURE__ */ (function () {
    return {
        encode: Foreign_Generic.genericEncode(genericExtraFeeItem)(Foreign_Generic_Class.genericEncodeConstructor(PackagingFeeItemIsSymbol)(Foreign_Generic_Class.genericEncodeArgsRecord(encodeWithOptionsRecord(encodeRecordCons(encodeRecordCons(encodeRecordCons1(typeIdIsSymbol)(encodeWithOptionsOther))(subjectIsSymbol)(Foreign_Generic_Class.encodeWithOptionsOther(encodePackagingFeeSubject)))(orderLineIndexIsSymbol)(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))({
            sumEncoding: encodingOptsExtraFeeItem.sumEncoding,
            unwrapSingleArguments: encodingOptsExtraFeeItem.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOptsExtraFeeItem.unwrapSingleRecordArguments,
            fieldTransform: encodingOptsExtraFeeItem.fieldTransform,
            unwrapSingleConstructors: false
        })
    };
})();
var decodePackagingFeeSubject = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPackagingFeeSubject)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ProductPackagingFeeSubjectIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ModifierItemPackagingFeeSubjectIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(modifierItemIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument)))
};
var decodeExtraFeeItem = /* #__PURE__ */ (function () {
    return {
        decode: Foreign_Generic.genericDecode(genericExtraFeeItem)(Foreign_Generic_Class.genericDecodeConstructor(PackagingFeeItemIsSymbol)(Foreign_Generic_Class.genericDecodeArgsRecord(decodeWithOptionsRecord(decodeRecordCons(decodeRecordCons(decodeRecordCons1(typeIdIsSymbol)(decodeWithOptionsOther)())(subjectIsSymbol)(Foreign_Generic_Class.decodeWithOptionsOther(decodePackagingFeeSubject))())(orderLineIndexIsSymbol)(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))({
            sumEncoding: encodingOptsExtraFeeItem.sumEncoding,
            unwrapSingleArguments: encodingOptsExtraFeeItem.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOptsExtraFeeItem.unwrapSingleRecordArguments,
            fieldTransform: encodingOptsExtraFeeItem.fieldTransform,
            unwrapSingleConstructors: false
        })
    };
})();
export {
    ProductPackagingFeeSubject,
    ModifierItemPackagingFeeSubject,
    encodingOptsExtraFeeItem,
    PackagingFeeItem,
    genericPackagingFeeSubject,
    eqPackagingFeeSubject,
    showPackagingFeeSubject,
    ordPackagingFeeSubject,
    encodePackagingFeeSubject,
    decodePackagingFeeSubject,
    unscrambleDecodePackagingFeeSubject,
    toFillFormTypePackagingFe,
    genericExtraFeeItem,
    eqExtraFeeItem,
    showExtraFeeItem,
    ordExtraFeeItem,
    encodeExtraFeeItem,
    decodeExtraFeeItem,
    unscrambleDecodeExtraFeeItem,
    toFillFormTypeExtraFeeIte
};
